import { useRootLoaderData } from "@made-people/gears-remix";
import { getMultipleStoriesFromGlobalStoryblokStoriesByComponentType } from "../utils/global-story-functions";

export const useStructuredDataSettings = () => {
  const rootLoaderData = useRootLoaderData();
  const structuredDataSettings =
    getMultipleStoriesFromGlobalStoryblokStoriesByComponentType(
      "StructuredData",
      rootLoaderData?.settingsAndContentResponse?.globalStoryblokStories,
    );
  return structuredDataSettings;
};
